/* eslint-disable */
import envGet from '../../Support/Env/Get/EnvGet.support';
import i18nValidateLang from '../../Support/I18n/ValidateLang/I18nValidateLang.support';
import i18nValidateLangExists from '../../Support/I18n/ValidateLangExists/I18nValidateLangExists.support';
import i18nValidateLocales from '../../Support/I18n/ValidateLocales/I18nValidateLocales.support';

export const I18N_DIRECTION_LEFT_TO_RIGHT = `ltr`;
export const I18N_DIRECTION_RIGHT_TO_LEFT = `rtl`;

/** @type {Array<I18nEntityLocale>} */
export const I18N_LOCALES = envGet({ key: `REACT_APP_I18N_LOCALES`, parse: true });
i18nValidateLocales(I18N_LOCALES, I18N_DIRECTION_LEFT_TO_RIGHT, I18N_DIRECTION_RIGHT_TO_LEFT);

/** @type {I18nEntityLangs} */
export const I18N_LANG = envGet({ key: `REACT_APP_I18N_LANG` });
i18nValidateLang(I18N_LANG);
i18nValidateLangExists(I18N_LANG, I18N_LOCALES);

export const I18N_LANG_AR_AE = `ar-AE`;
export const I18N_LANG_EN_AU = `en-AU`;
export const I18N_LANG_EN_US = `en-US`;
export const I18N_LANG_ZH_CN = `zh-CN`;
i18nValidateLangExists(I18N_LANG_AR_AE, I18N_LOCALES);
i18nValidateLangExists(I18N_LANG_EN_AU, I18N_LOCALES);
i18nValidateLangExists(I18N_LANG_ZH_CN, I18N_LOCALES);
export const I18N_LANGS = [I18N_LANG_AR_AE, I18N_LANG_EN_AU, I18N_LANG_EN_US, I18N_LANG_ZH_CN];

export const I18N_PERSIST_KEY = `bds:i18n`;
